function checkSelectRepeatOrder() {
  const repeatItemList = JSON.parse(localStorage.getItem('repeatItemList'));
  let bool = [];
  for (var i = 0; i < repeatItemList.length; i++) {
    bool.push(repeatItemList[i].itemList.some(val => val.repeatOrder));
  }
  let result = bool.some(val => val);
  return result;
}
export default {
  checkSelectRepeatOrder,
}



// WEBPACK FOOTER //
// ./src/model/checkSelectRepeatOrder.js